import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import * as AiIcons from "react-icons/ai";
import * as BiIcons from "react-icons/bi";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  Button,
  Row,
  Col,
  Spinner,
  Alert,
  Modal,
  ModalBody,
  ModalFooter,
  Container,
} from "reactstrap";

import { getTheory, getInstitute } from "../../../redux/features/customerSlice";
import LayoutAdmin from "../LayoutAdmin";
import { InstituteApi, DeleteInstituteApi } from "../../../services";
import { storage } from "../../../config/FirebaseConfig";

const { SearchBar } = Search;

const AdminInstitute = () => {
  const [listInstitute, setListInstitute] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [institute, setInstitute] = useState({});
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const { customer } = useSelector((state) => state);
  const { theoryType } = useSelector((state) => state);

  const dispatch = useDispatch();

  const deleteInstitute = (data) => {
    setInstitute(data);
    setModal(!modal);
  };

  useEffect(() => {
    const fetchInstitute = async () => {
      setLoading(true);
      const res = await InstituteApi(customer.token);

      if (res && res.statusCode === 20) {
        setListInstitute(res.result);
        setLoading(false);
      } else {
        setError(true);
        setLoading(false);
      }
    };
    fetchInstitute();
  }, [customer, theoryType]);

  const columns = [
    //Don't Delete This
    // {
    //   dataField: "secureId",
    //   text: "Schedule ID",
    //   sort: true,
    // },
    {
      dataField: "description",
      text: "Description",
      formatter: (rowContent, row) => {
        return (
          <a href={row.uri} target="_blank">
            {row.description}
          </a>
        );
      },
      sort: true,
    },
    // {
    //   dataField: "uri",
    //   text: "Uri",
    //   formatter: (rowContent, row) => {
    //     console.log("row");
    //     console.log(row);
    //     return (
    //       <Container fluid>
    //         <a href={row.uri} target="_blank">
    //           {row.uri.substring(0, 100) + "..."}
    //         </a>
    //       </Container>
    //     );
    //   },
    //   sort: true,
    // },
    {
      dataField: "link",
      text: "Action",
      formatter: (rowContent, row) => {
        return (
          <div>
            <Row>
              {/* <Col>
                <Link to={`/admin/institute/update`}>
                  <Button
                    color="warning"
                    onClick={() => dispatch(getInstitute(row))}
                  >
                    <AiIcons.AiOutlineEdit />
                  </Button>
                </Link>
              </Col> */}
              <Col className="text-center">
                <Button color="danger" onClick={() => deleteInstitute(row)}>
                  <AiIcons.AiOutlineDelete />
                </Button>
              </Col>
            </Row>
          </div>
        );
      },
      headerStyle: () => {
        return { width: "130px" };
      },
      sort: true,
    },
  ];

  const defaultSorted = [
    {
      dataField: "secureId",
      order: "asc",
    },
  ];

  console.log(institute);

  return (
    <LayoutAdmin>
      <h1>Institute </h1>

      <Modal isOpen={modal} toggle={toggle}>
        {/* <ModalHeader toggle={toggle}>{schedule.desc}</ModalHeader> */}
        <ModalBody>
          <p className="text-center">
            <strong>Detail</strong>
          </p>
          <ul>
            <li>Description : {institute.description}</li>
            {/* <li>value : {theory.uri}</li> */}
          </ul>
          <h5 className="text-center">
            Apakah Anda Yakin Akan Menghapus Data?
          </h5>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={async () => {
              toggle();
              await DeleteInstituteApi(institute.secureId, customer.token);
              let fileRef = storage.refFromURL(institute.uri);
              // Delete the file
              fileRef
                .delete()
                .then(function () {
                  setIsDelete(true);
                  console.log("delete file berhasil.");
                  // File deleted successfully
                })
                .catch(function (error) {
                  console.log("delete file gagal.");
                  // Uh-oh, an error occurred!
                });
              setListInstitute(
                listInstitute.filter((item) => {
                  return item.secureId !== institute.secureId;
                })
              );
            }}
          >
            Ya
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Tidak
          </Button>
        </ModalFooter>
      </Modal>
      {isDelete && <Alert color="success">Data berhasil dihapus.</Alert>}
      <ToolkitProvider
        bootstrap4
        defaultSorted={defaultSorted}
        keyField="secureId"
        data={listInstitute}
        columns={columns}
        search
      >
        {(props) => (
          <div>
            <Row>
              <Col>
                <Link to="/admin/institute/create">
                  <Button color="primary mt-4">
                    <BiIcons.BiBookOpen /> Buat
                  </Button>
                </Link>
              </Col>
              <Col>
                <div className="offset-8 mb-2">
                  <SearchBar {...props.searchProps} />
                </div>
              </Col>
            </Row>

            {loading ? (
              <div className="text-center">
                <Spinner style={{ width: "7.5rem", height: "7.5rem" }} />
              </div>
            ) : (
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory()}
              />
            )}
            {error && (
              <Alert color="danger">
                Terjadi Kesalahan saat pegambilan Data
              </Alert>
            )}
          </div>
        )}
      </ToolkitProvider>
    </LayoutAdmin>
  );
};

export default AdminInstitute;
